gsap.registerPlugin(ScrollTrigger);

let matchMedia = gsap.matchMedia();

function removeStyle(tag) {
  document.querySelectorAll(tag).forEach(el => {
    el.removeAttribute("style"); // Removes all inline styles set by GSAP
  });
}

function imageListAnimation() {
  removeStyle('.Bottom_right_position_new')
  removeStyle('.Top_left_position_new')
  removeStyle('.Top_right_position_new')
  removeStyle('.Bottom_left_position_new')

  let start = 'top';
  let end = '400px';

  if(window.innerWidth > 767) {
    ScrollTrigger.create({
      trigger: ".Index_images_lists_texts_main_new",
      start: "top top",
      end: "bottom top",
      pin: true, 
      pinSpacing: true, 
      markers: false
    });
  } else {
    start = '-500px top';
    end = '100px';
  }
  
  function createAnimation(settings) {
    const { selector, trigger, duration, fromStyles, start, end } = settings;
    gsap.from(selector, {
      duration,
      ...fromStyles,
      scrollTrigger: {
        trigger,
        start,
        end,
        scrub: true,
        toggleActions: "play reverse play reverse",
        markers: false,
      }
    });
  }
  
  function animateBoxes(viewportSettings) {
    viewportSettings.forEach(setting => {
      createAnimation({
        selector: setting.selector,
        trigger: setting.trigger || ".Index_images_lists_texts_main_new",
        duration: setting.duration || 0.5,
        fromStyles: setting.fromStyles,
        start: setting.start || start,
        end: setting.end || end,
      });
    });
  }
  
  matchMedia.add("(min-width: 1440px)", () => {
    gsap.set(".Bottom_right_position_new", { bottom: 0, right: 0, width: 280 });
    gsap.set(".Top_left_position_new", { top: "0", left: 180, width: 240 });
    gsap.set(".Top_right_position_new", { top: 32, right: 140, width: 400 });
    gsap.set(".Bottom_left_position_new", { left: 50, bottom: 0, width: 232 });
  
    animateBoxes([
      {
        selector: ".Bottom_right_position_new",
        fromStyles: { top: 33, left: "50%", x: "-50%", width: 624 },
      },
      {
        selector: ".Top_left_position_new",
        fromStyles: { top: 97, left: "50%", x: "-50%", width: 500 },
      },
      {
        selector: ".Top_right_position_new",
        fromStyles: { top: "50%", left: "50%", x: "-50%", y: "-50%", width: 859 },
      },
      {
        selector: ".Bottom_left_position_new",
        fromStyles: { top: 0, left: "50%", x: "-50%", width: 488 },
      },
    ]);
  
    return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  });
  
  matchMedia.add("(min-width: 991px) and (max-width: 1439px)", () => {
    gsap.set(".Bottom_right_position_new", { right: 0, bottom: 0, width: 260 });
    gsap.set(".Top_left_position_new", { top: 0, left: 80, width: 200 });
    gsap.set(".Top_right_position_new", { top: 32, right: 90, width: 360 });
    gsap.set(".Bottom_left_position_new", { left: 20, bottom: 0, width: 230 });
  
    animateBoxes([
      {
        selector: ".Bottom_right_position_new",
        fromStyles: { top: 0, left: "50%", x: "-50%", width: 524 },
      },
      {
        selector: ".Top_left_position_new",
        fromStyles: { top: "50%", left: "50%", x: "-50%", y: "-50%", width: 459 },
      },
      {
        selector: ".Top_right_position_new",
        fromStyles: { top: "50%", left: "50%", x: "-50%", y: "-50%", width: 699 },
      },
      {
        selector: ".Bottom_left_position_new",
        fromStyles: { top: 0, left: "50%", x: "-50%", width: 418 },
      }
    ]);
  
    return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  });
  
  matchMedia.add("(min-width: 750px) and (max-width: 990px)", () => {
    gsap.set(".Top_left_position_new", { top: 0, left: 40, width: 180 });
    gsap.set(".Top_right_position_new", { top: 32, right: 30, width: 280 });
    gsap.set(".Bottom_left_position_new", { bottom: 0, left: 20, width: 160 });
    gsap.set(".Bottom_right_position_new", { bottom: 0, right: 0, width: 200 });
  
    animateBoxes([
      {
        selector: ".Top_left_position_new",
        fromStyles: { top: "50%", left: "50%", x: "-50%", y: "-50%", width: 460 },
      },
      {
        selector: ".Top_right_position_new",
        fromStyles: { top: "50%", left: "50%", x: "-50%", y: "-50%", width: 699 },
      },
      {
        selector: ".Bottom_left_position_new",
        fromStyles: { top: 0, left: "50%", x: "-50%", width: 418 },
      },
      {
        selector: ".Bottom_right_position_new",
        fromStyles: { top: 0, left: "50%", x: "-50%", width: 524 },
      },
    ]);
  
    return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  });
  
  matchMedia.add("(min-width: 0px) and (max-width: 749px)", () => {
    gsap.set(".Top_left_position_new", { top: 0, left: 0, width: 128 });
    gsap.set(".Top_right_position_new", { top: 60, right: 0, left: "auto", width: 176 });
    gsap.set(".Bottom_left_position_new", { bottom: 0,top: "auto",left: 26, width: 104 });
    gsap.set(".Bottom_right_position_new", { bottom: 11, right: 0,  left: "auto", top: "auto", width: 120 });
  
    animateBoxes([
      {
        selector: ".Top_left_position_new",
        fromStyles: { top: "50%", left: "50%", x: "-50%", y: "-50%", width: 240 },
      },
      {
        selector: ".Top_right_position_new",
        fromStyles: { top:260, left: "50%", x: "-50%", width: 336 },
      },
      {
        selector: ".Bottom_left_position_new",
        fromStyles: { top: 204, left: "50%", x: "-50%", width: 194 },
      },
      {
        selector: ".Bottom_right_position_new",
        fromStyles: { top: 245, left: "50%", x: "-50%", width: 225 },
      },
    ]);
  
    return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
  });
}

imageListAnimation()

document.addEventListener("DOMContentLoaded", () => {
  scrollTriggerRefresh()
})


function scrollTriggerRefresh(){
  const targetElement = document.querySelector(".Page_object_tabs_classes_mainloops_new");
  if (!targetElement) return;
  const observer = new IntersectionObserver((entries) => {
     
      entries.forEach(entry => {
          if (entry.isIntersecting) {
            gsap.killTweensOf("*");
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
            imageListAnimation()
          } else {
            gsap.killTweensOf("*");
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
            imageListAnimation()
          }
      });

  }, {
      root: null, 
      threshold: 0.1 
  });

  observer.observe(targetElement);
}